/**
 * @generated SignedSource<<9d7f234067950d86100d3eda9fcf682d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhaseItem_project$data = {
  readonly budget_method: any;
  readonly id: number;
  readonly is_template: boolean;
  readonly " $fragmentType": "PhaseItem_project";
};
export type PhaseItem_project$key = {
  readonly " $data"?: PhaseItem_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhaseItem_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhaseItem_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budget_method",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "is_template",
      "storageKey": null
    }
  ],
  "type": "projects",
  "abstractKey": null
};

(node as any).hash = "2057023a70143adb83f27a82d369a9b9";

export default node;
